import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Checkbox,
  Input,
  Button,
  Stack,
  Spinner,
  InputGroup,
  InputLeftElement,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Textarea,
  Icon,
  SimpleGrid,
  IconButton,
  Flex,
  Wrap,
  WrapItem,
  FormControl,
  useDisclosure,
  HStack,
  Skeleton,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  SearchIcon,
  DownloadIcon,
  CheckIcon,
  CloseIcon,
} from '@chakra-ui/icons';
import { MdClear, MdLocationOn, MdImage, MdInfo } from 'react-icons/md';
import {
  FaUserShield,
  FaLandmark,
  FaTools,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { FiDownload } from 'react-icons/fi';
import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Select } from 'antd';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { FiCalendar } from 'react-icons/fi';
import { MdStraighten } from 'react-icons/md';
import { useRef } from 'react';
import axiosInstance from 'axiosInstance';
import { useDispatch } from 'react-redux';
import { fetchSurveyStats } from '../../../redux/slices/surveyStatsSlice';
import Swal from 'sweetalert2';
import { IoHourglassOutline } from 'react-icons/io5';
import { Image } from '@chakra-ui/react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { useColorMode } from '@chakra-ui/react';
import './index.css';

export default function PendingList() {
  const [surveyData, setSurveyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSurveyIds, setSelectedSurveyIds] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchInput, setSearchInput] = useState('');
  const [statusFilter, setStatusFilter] = useState('pending');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [areaRange, setAreaRange] = useState({ min: '', max: '' });
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [typeOfEncroachmentFilter, setTypeOfEncroachmentFilter] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [remark, setRemark] = useState('');
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [comparisonData, setComparisonData] = useState(null);
  const endDateRef = useRef(null);
  const dispatch = useDispatch();

  const bgColor = useColorModeValue('white', 'gray.700');
  const color = useColorModeValue('gray.800', 'gray.100');
  const colorBlack = useColorModeValue('black', 'white');
  const { colorMode } = useColorMode();
  const headerGradient = useColorModeValue(
    'linear(to-r, blue.400, green.400)',
    'linear(to-r, blue.600, green.600)',
  );
  const hoverRowBg = useColorModeValue('gray.200', 'gray.600');
  const tableBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const rowEvenBg = useColorModeValue('#ECF8FF', 'gray.700');
  const rowOddBg = useColorModeValue('white', 'gray.800');
  const user = useMemo(() => JSON.parse(localStorage.getItem('user')), []);
  const token = useMemo(() => localStorage.getItem('token'), []);
  const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);

  useEffect(() => {
    try {
      const encParam = searchParams.get('encroachments');
      const parsedEncroachments = encParam ? JSON.parse(encParam) : [];
      if (parsedEncroachments.length > 0) {
        setTypeOfEncroachmentFilter(parsedEncroachments);
      }

      const catParam = searchParams.get('category');
      const parsedCategory = catParam ? JSON.parse(catParam) : [];
      if (parsedCategory.length > 0) {
        setCategoryFilter(parsedCategory);
      }

      const areaMin = searchParams.get('minArea');
      const areaMax = searchParams.get('maxArea');
      if (areaMin || areaMax) {
        setAreaRange({ min: areaMin || '', max: areaMax || '' });
      }

      const searchStr = searchParams.get('search');
      if (searchStr) {
        setSearchInput(searchStr);
      }

      const start = searchParams.get('startDate');
      const end = searchParams.get('endDate');
      if (start && end) {
        setStartDate(moment(start).toDate());
        setEndDate(moment(end).toDate());
      }

      const pageParam = parseInt(searchParams.get('page')) || 1;
      setPage(pageParam);
    } catch (err) {
      console.error('Failed to parse filters from URL:', err);
    }
  }, []);

  const syncUrlParams = ({
    search = '',
    startDate = '',
    endDate = '',
    page = 1,
    minArea = '',
    maxArea = '',
    category = [],
    encroachments = [],
  }) => {
    const newParams = new URLSearchParams();

    if (search) newParams.set('search', search);
    if (startDate) newParams.set('startDate', startDate);
    if (endDate) newParams.set('endDate', endDate);
    if (page && page !== 1) newParams.set('page', page);
    else newParams.delete('page');
    if (minArea) newParams.set('minArea', minArea);
    if (maxArea) newParams.set('maxArea', maxArea);
    if (category.length > 0)
      newParams.set('category', JSON.stringify(category));
    if (encroachments.length > 0)
      newParams.set('encroachments', JSON.stringify(encroachments));

    setSearchParams(newParams);
  };

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page')) || 1;
    const search = searchParams.get('search') || '';
    const start = searchParams.get('startDate') || '';
    const end = searchParams.get('endDate') || '';
    const minArea = searchParams.get('minArea') || '';
    const maxArea = searchParams.get('maxArea') || '';

    let category = [];
    try {
      category = JSON.parse(searchParams.get('category')) || [];
    } catch (e) {
      category = [];
    }

    let encroachments = [];
    try {
      encroachments = JSON.parse(searchParams.get('encroachments')) || [];
    } catch (e) {
      encroachments = [];
    }

    if (page !== pageParam) setPage(pageParam);
    if (searchInput !== search) setSearchInput(search);
    if (startDate !== start) setStartDate(start);
    if (endDate !== end) setEndDate(end);
    if (areaRange.min !== minArea || areaRange.max !== maxArea) {
      setAreaRange({ min: minArea, max: maxArea });
    }
    if (JSON.stringify(categoryFilter) !== JSON.stringify(category)) {
      setCategoryFilter(category);
    }
    if (
      JSON.stringify(typeOfEncroachmentFilter) !== JSON.stringify(encroachments)
    ) {
      setTypeOfEncroachmentFilter(encroachments);
    }
  }, [searchParams]);

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page'));
    if (!isNaN(pageParam) && pageParam !== page) {
      setPage(pageParam);
    }
  }, [searchParams.get('page')]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      setPage(1);
      syncUrlParams({
        search: searchInput,
        startDate,
        endDate,
        page: 1,
        minArea: areaRange.min,
        maxArea: areaRange.max,
        category: categoryFilter,
        encroachments: typeOfEncroachmentFilter,
      });
    }, 500);
    return () => clearTimeout(debounce);
  }, [
    searchInput,
    startDate,
    endDate,
    areaRange.min,
    areaRange.max,
    categoryFilter,
    typeOfEncroachmentFilter,
  ]);

  const queryParams = useMemo(() => {
    const params = { page, limit: rowsPerPage };
    const filter = { status: 'pending' };

    if (searchInput) filter.searchString = searchInput;
    if (startDate && endDate) {
      filter.startDate = moment(startDate).format('YYYY-MM-DD');
      filter.endDate = moment(endDate).format('YYYY-MM-DD');
    }
    if (areaRange.min) filter.minEncroachedArea = areaRange.min;
    if (areaRange.max) filter.maxEncroachedArea = areaRange.max;
    if (categoryFilter.length > 0) filter.category = categoryFilter;
    if (typeOfEncroachmentFilter.length > 0)
      filter.typeOfEncroachment = typeOfEncroachmentFilter;

    if (Object.keys(filter).length > 0) {
      params.filter = JSON.stringify(filter);
    }

    return params;
  }, [
    page,
    rowsPerPage,
    searchInput,
    startDate,
    endDate,
    areaRange,
    categoryFilter,
    typeOfEncroachmentFilter,
  ]);

  const queryParamsforExcelData = useMemo(() => {
    const params = {};
    const filter = { status: 'pending' };

    if (searchInput) filter.searchString = searchInput;
    if (startDate && endDate) {
      filter.startDate = moment(startDate).format('YYYY-MM-DD');
      filter.endDate = moment(endDate).format('YYYY-MM-DD');
    }
    if (areaRange.min) filter.minEncroachedArea = areaRange.min;
    if (areaRange.max) filter.maxEncroachedArea = areaRange.max;
    if (categoryFilter.length > 0) filter.category = categoryFilter;
    if (typeOfEncroachmentFilter.length > 0)
      filter.typeOfEncroachment = typeOfEncroachmentFilter;

    if (Object.keys(filter).length > 0) {
      params.filter = JSON.stringify(filter);
    }

    return params;
  }, [
    searchInput,
    startDate,
    endDate,
    areaRange,
    categoryFilter,
    typeOfEncroachmentFilter,
  ]);

  const fetchSurveys = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/survey/all-surveys?${Object.keys(queryParams)
          .filter(
            (key) => queryParams[key] !== undefined && queryParams[key] !== '',
          )
          .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
          .join('&')}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const result = response.data.data;
      setSurveyData(Array.isArray(result.data) ? result.data : []);
      setPage(result.page);
      setTotalPages(result.totalPages);
      setTotalResult(result.totalResults);
    } catch (err) {
      setError(`Failed to fetch survey data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [queryParams, token]);

  useEffect(() => {
    fetchSurveys();
  }, [
    fetchSurveys,
    searchInput,
    startDate,
    endDate,
    areaRange.min,
    areaRange.max,
    categoryFilter,
    typeOfEncroachmentFilter,
    page,
    rowsPerPage,
  ]);

  const handleBulkApprove = useCallback(async () => {
    if (selectedSurveyIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are approving ${selectedSurveyIds.length} selected surveys.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, approve',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    try {
      await axios.put(
        `${baseUrl}/survey/update-multiple`,
        { surveyIds: selectedSurveyIds, status: 'approved' },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast({
        title: 'Selected surveys approved successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setSelectedSurveyIds([]);
      fetchSurveys();
      dispatch(fetchSurveyStats());
    } catch (err) {
      toast({
        title:
          err.response?.status === 401
            ? 'Only Tahsildar is allowed to approve pending list.'
            : 'Failed to approve selected surveys.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  }, [selectedSurveyIds, token, toast, fetchSurveys]);

  const handleBulkReject = useCallback(async () => {
    if (selectedSurveyIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to reject ${selectedSurveyIds.length} selected surveys.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e53e3e',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, reject',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;
    try {
      await axios.put(
        `${baseUrl}/survey/update-multiple`,
        { surveyIds: selectedSurveyIds, status: 'rejected' },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast({
        title: 'Selected surveys rejected successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setSelectedSurveyIds([]);
      fetchSurveys();
      dispatch(fetchSurveyStats());
    } catch (err) {
      toast({
        title:
          err.response?.status === 401
            ? 'Only Tahsildar is allowed to reject pending list.'
            : 'Failed to reject selected surveys.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  }, [selectedSurveyIds, token, toast, fetchSurveys]);

  const fetchComparisonSurvey = useCallback(
    async (surveyId) => {
      setLoading(true);
      try {
        const response = await axios.get(
          ` ${baseUrl}/survey/get-comparison-survey/${surveyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = response?.data?.data;

        if (!result) {
          console.warn('No valid comparison data returned.');
          return null;
        }

        return result;
      } catch (err) {
        setError(`Failed to fetch comparison data: ${err.message}`);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  const handleViewClick = useCallback(
    async (survey) => {
      setSelectedSurvey(survey);
      setRemark('');
      onOpen();

      if (survey.status === 'pending') {
        const surveyId = survey?.surveyId;
        console.log('surveyid ', surveyId);

        try {
          const comparison = await fetchComparisonSurvey(surveyId);
          console.log('comparison----------', comparison);

          if (!comparison) {
            setComparisonData(null);
            console.warn('No comparison available for this survey.');
          } else {
            setComparisonData(comparison);
          }
        } catch (err) {
          console.error('Failed to fetch comparison survey:', err);
        }
      } else {
        setComparisonData(null);
      }
    },
    [onOpen],
  );

  const downloadPDF = useCallback(
    async (ids) => {
      if (ids.length === 0) return;
      setIsDownloading(true);
      try {
        const response = await axios.post(
          `${baseUrl}/survey/export-pdf-file`,
          { ids },
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob',
          },
        );

        const isZip = ids.length > 1;
        const mimeType = isZip ? 'application/zip' : 'application/pdf';
        const fileName = isZip ? 'surveys.zip' : 'survey.pdf';

        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        toast({
          title: 'Download failed',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsDownloading(false);
      }
    },
    [token, toast],
  );
  const hasValue = (value) =>
    value !== null && value !== undefined && value !== '';

  const capitalizeFirst = (text) => {
    if (!text || typeof text !== 'string') return 'N/A';
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const handlePageChange = useCallback(
    (newPage) => {
      setPage(newPage);
      syncUrlParams({
        search: searchInput,
        startDate,
        endDate,
        page: newPage,
        minArea: areaRange.min,
        maxArea: areaRange.max,
        category: categoryFilter,
        encroachments: typeOfEncroachmentFilter,
      });
    },
    [
      searchInput,
      startDate,
      endDate,
      areaRange,
      categoryFilter,
      typeOfEncroachmentFilter,
    ],
  );

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const approveSurvey = async () => {
    setIsApproving(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${baseUrl}/survey/update-multiple`,
        {
          surveyIds: [selectedSurvey._id],
          status: 'approved',
          ...(remark && { remark }),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.code === 200) {
        toast({
          title: 'Survey approved successfully.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }

      fetchSurveys();
      onClose();
      dispatch(fetchSurveyStats());
    } catch (error) {
      console.error('Failed to approve survey:', error);
      toast({
        title: 'Failed to approve the survey.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsApproving(false);
    }
  };

  const rejectSurvey = async () => {
    if (!remark.trim()) {
      toast({
        title: 'Remark is required for rejection.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setIsRejecting(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${baseUrl}/survey/update-multiple`,
        {
          surveyIds: [selectedSurvey._id],
          status: 'rejected',
          remark: remark.trim(),
          rejectionComment: remark.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.code === 200) {
        toast({
          title: 'Survey rejected successfully.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }

      fetchSurveys();
      dispatch(fetchSurveyStats());
      onClose();
    } catch (error) {
      console.error('Failed to reject survey:', error);
      toast({
        title: 'Failed to reject the survey.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsRejecting(false);
    }
  };

  const renderPagination = () => {
    const maxPagesToShow = 5;
    const pages = [];
    const isEllipsisShown = totalPages > maxPagesToShow;

    const createPageButton = (pageNumber) => (
      <Button
        key={pageNumber}
        onClick={() => handlePageChange(pageNumber)}
        colorScheme={page === pageNumber ? 'blue' : 'gray'}
        variant={page === pageNumber ? 'solid' : 'outline'}
        mx="1"
      >
        {pageNumber}
      </Button>
    );

    if (isEllipsisShown) {
      if (page > Math.ceil(maxPagesToShow / 2)) {
        pages.push(createPageButton(1));
        pages.push(
          <Text key="ellipsis-start" mx="1" fontSize="lg">
            ...
          </Text>,
        );
      }

      const startPage = Math.max(page - Math.floor(maxPagesToShow / 2), 1);
      const endPage = Math.min(
        page + Math.floor(maxPagesToShow / 2),
        totalPages,
      );
      for (let i = startPage; i <= endPage; i++) {
        pages.push(createPageButton(i));
      }

      if (page < totalPages - Math.floor(maxPagesToShow / 2)) {
        pages.push(
          <Text key="ellipsis-end" mx="1" fontSize="lg">
            ...
          </Text>,
        );
        pages.push(createPageButton(totalPages));
      }
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(createPageButton(i));
      }
    }

    return (
      <Flex mt="4" justify="center" align="center">
        <IconButton
          aria-label="Previous Page"
          icon={<ChevronLeftIcon />}
          isDisabled={page <= 1}
          onClick={() => handlePageChange(page - 1)}
          mr="2"
        />
        {pages}
        <IconButton
          aria-label="Next Page"
          icon={<ChevronRightIcon />}
          isDisabled={page >= totalPages}
          onClick={() => handlePageChange(page + 1)}
          ml="2"
        />
      </Flex>
    );
  };

  const inputBgColor = useColorModeValue('white', 'gray.700');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const iconColor = useColorModeValue('gray.400', 'gray.300');
  const modalHeaderBg = useColorModeValue(
    'linear-gradient(to right, #4299e1, #3182ce)',
    'linear-gradient(to right, #2a4365, #1A365D)',
  );
  const modalHeaderColor = useColorModeValue('white', 'gray.100');
  const sectionHeadingColor = useColorModeValue('blue.500', 'blue.300');
  const sectionBoxBg = useColorModeValue('gray.50', 'gray.700');
  const sectionTextColor = useColorModeValue('gray.800', 'gray.100');
  const sectionBorderColor = useColorModeValue('gray.200', 'gray.600');
  const headingColor = useColorModeValue('green.600', 'green.300');
  const sectionTitleColor = useColorModeValue('orange.500', 'orange.300');
  const boxBg = useColorModeValue('gray.50', 'gray.700');
  const previousColor = useColorModeValue('red.500', 'red.300');
  const linkColor = useColorModeValue('blue.600', 'blue.300');
  const mapLinkColor = useColorModeValue('green.600', 'green.300');
  const sectionRedTitleColor = useColorModeValue('red.500', 'red.300');
  const hrColor = useColorModeValue('black', 'gray.300');
  const inputBg = useColorModeValue('white', 'gray.600');

  return (
    <Box pt={{ base: '140px', md: '90px' }} px={{ base: '4', md: '8' }}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'start', md: 'center' }}
        gap={4}
        mb={4}
      >
        <Flex align="center" gap={2}>
          <IoHourglassOutline size="20" color="#4B80DE" />
          <Text fontSize="xl" fontWeight="bold">
            Pending Surveys
          </Text>
        </Flex>
        <Wrap
          spacing={2}
          justify={{ base: 'start', md: 'end' }}
          flexWrap="wrap"
        >
          {selectedSurveyIds.length > 0 && (
            <WrapItem>
              <Flex gap={2}>
                <Button
                  size="sm"
                  colorScheme="green"
                  onClick={handleBulkApprove}
                  leftIcon={<CheckIcon />}
                >
                  Approve Selected ({selectedSurveyIds.length})
                </Button>
                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={handleBulkReject}
                  leftIcon={<CloseIcon />}
                >
                  Reject Selected ({selectedSurveyIds.length})
                </Button>
              </Flex>
            </WrapItem>
          )}
          {selectedIds.length > 0 && (
            <WrapItem>
              <Button
                size="sm"
                leftIcon={
                  isDownloading ? <Spinner size="sm" /> : <FiDownload />
                }
                onClick={() => downloadPDF(selectedIds)}
                colorScheme="green"
                isDisabled={isDownloading}
              >
                {isDownloading
                  ? 'Downloading...'
                  : `Download PDF Selected (${selectedIds.length})`}
              </Button>
            </WrapItem>
          )}
        </Wrap>
      </Flex>

      {/* <Accordion defaultIndex={[0]} allowToggle mb={4}>
        <AccordionItem
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          overflow="hidden"
          bg={bgColor}
          boxShadow="sm"
        >
          <h2>
            <AccordionButton
              px={4}
              py={3}
              _expanded={{ bg: 'pink.50', color: 'pink.600' }}
              _hover={{ bg: 'gray.50' }}
            >
              <Box
                flex="1"
                textAlign="left"
                fontWeight="semibold"
                fontSize="md"
              >
                Filters
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel px={4} pt={4} pb={2} bg={bgColor}>
            
          </AccordionPanel>
        </AccordionItem>
      </Accordion> */}

      <Stack mb={4} spacing={4} w="100%">
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 2, lg: 3 }}
          spacing={{ base: 3, md: 4 }}
          w="100%"
        >
          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color={color} />
            </InputLeftElement>
            <Input
              bg={bgColor}
              placeholder="Search By Name,Gat No..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              aria-label="Search Input"
              color={textColor}
              _placeholder={{ color: placeholderColor }}
            />
          </InputGroup>

          <Flex align="center" gap={2}>
            <Box zIndex={10} position="relative">
              <FormControl>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" height="100%" pl={3}>
                    <Icon as={FiCalendar} color={color} boxSize={4} />
                  </InputLeftElement>

                  <DatePicker
                    selected={startDate ? new Date(startDate) : null}
                    onChange={(date) => {
                      if (!date) return setStartDate('');
                      const formatted = moment(date).format('YYYY-MM-DD');
                      setStartDate(formatted);
                      if (endDate && new Date(formatted) > new Date(endDate)) {
                        setEndDate('');
                      }
                      if (endDateRef.current) {
                        endDateRef.current.setFocus();
                      }
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Start Date"
                    minDate={new Date()}
                    customInput={
                      <Input
                        size="sm"
                        bg={bgColor}
                        pl={10}
                        height="34px"
                        color={textColor}
                        _placeholder={{ color: placeholderColor }}
                      />
                    }
                  />
                </InputGroup>
              </FormControl>
            </Box>

            <Text fontSize="sm" my={2} textAlign="center">
              to
            </Text>
            <Box zIndex={9} position="relative">
              <FormControl>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" height="100%" pl={3}>
                    <Icon as={FiCalendar} color={color} boxSize={4} />
                  </InputLeftElement>

                  <DatePicker
                    selected={endDate ? new Date(endDate) : null}
                    onChange={(date) => {
                      if (!date) return setEndDate('');
                      const formatted = moment(date).format('YYYY-MM-DD');
                      if (
                        startDate &&
                        new Date(formatted) < new Date(startDate)
                      ) {
                        toast({
                          title: 'Invalid end date',
                          description: 'End date cannot be before start date',
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return;
                      }
                      setEndDate(formatted);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="End Date"
                    disabled={!startDate}
                    minDate={startDate ? new Date(startDate) : new Date()}
                    customInput={
                      <Input
                        color={textColor}
                        _placeholder={{ color: placeholderColor }}
                        size="sm"
                        bg={bgColor}
                        pl={10}
                        height="34px"
                      />
                    }
                  />
                </InputGroup>
              </FormControl>
            </Box>
          </Flex>

          <HStack spacing={2}>
            <FormControl>
              <InputGroup>
                <InputLeftElement pointerEvents="none" pl={2}>
                  <Icon as={MdStraighten} color={color} boxSize={4} mb={2} />
                </InputLeftElement>
                <Input
                  size="sm"
                  type="number"
                  placeholder="Min Area in Hectares"
                  value={areaRange.min}
                  bg={bgColor}
                  pl={10}
                  onChange={(e) =>
                    setAreaRange((prev) => ({
                      ...prev,
                      min: e.target.value,
                    }))
                  }
                  color={textColor}
                  _placeholder={{ color: placeholderColor }}
                />
              </InputGroup>
            </FormControl>

            <Text fontSize="sm" textAlign="center" my={2}>
              to
            </Text>

            <FormControl>
              <InputGroup>
                <InputLeftElement pointerEvents="none" pl={2}>
                  <Icon as={MdStraighten} color={color} boxSize={4} mb={2} />
                </InputLeftElement>
                <Input
                  size="sm"
                  type="number"
                  placeholder="Max Area in Hectares"
                  value={areaRange.max}
                  bg={bgColor}
                  pl={10}
                  disabled={!areaRange.min || areaRange.min === ''}
                  onChange={(e) =>
                    setAreaRange((prev) => ({
                      ...prev,
                      max: e.target.value,
                    }))
                  }
                  color={textColor}
                  _placeholder={{ color: placeholderColor }}
                />
              </InputGroup>
            </FormControl>
          </HStack>

          <FormControl>
            <Select
              mode="multiple"
              allowClear
              size="small"
              placeholder="Filter by Caste"
              value={categoryFilter}
              onChange={(values) => setCategoryFilter(values)}
              style={{ width: '100%' }}
              className={colorMode === 'dark' ? 'ant-select-dark' : ''}
              options={[
                'SC',
                'ST',
                'OBC',
                'VJNT',
                'SBC',
                'OPEN',
                'NT-A',
                'NT-B',
                'NT-C',
                'NT-D',
                'Other',
              ].map((val) => ({ value: val, label: val }))}
            />
          </FormControl>

          <FormControl>
            <Select
              mode="multiple"
              allowClear
              className={colorMode === 'dark' ? 'ant-select-dark' : ''}
              size="small"
              placeholder="Type of Encroachment"
              value={typeOfEncroachmentFilter}
              onChange={(values) => setTypeOfEncroachmentFilter(values)}
              style={{ width: '100%' }}
              options={[
                { value: 'rawHouse', label: 'Raw House' },
                { value: 'tinShed', label: 'Concrete House' },
                { value: 'slum', label: 'Slum' },
                {
                  value: 'govtEmployeesColony',
                  label: 'Govt. Employees Colony',
                },
                { value: 'govtSchool', label: 'Govt. School' },
                { value: 'privateSchool', label: 'Private School' },
                {
                  value: 'commercialTemporary',
                  label: 'Commercial (Temporary)',
                },
                {
                  value: 'commercialPermanent',
                  label: 'Commercial (Permanent)',
                },
                { value: 'mall', label: 'Mall and Mall Like' },
                { value: 'publicUtilities', label: 'Public Utilities' },
                { value: 'publicPurpose', label: 'Public Purpose' },
                { value: 'agriculture', label: 'Agriculture' },
                { value: 'other', label: 'Other' },
              ]}
            />
          </FormControl>
        </SimpleGrid>
      </Stack>

      {(searchInput.trim() !== '' ||
        startDate !== '' ||
        endDate !== '' ||
        areaRange.min !== '' ||
        areaRange.max !== '' ||
        categoryFilter.length > 0 ||
        typeOfEncroachmentFilter.length > 0) && (
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button
            size="sm"
            leftIcon={<MdClear />}
            colorScheme="red"
            variant="solid"
            onClick={() => {
              setSearchInput('');
              setStartDate('');
              setEndDate('');
              setPage(1);
              setAreaRange({ min: '', max: '' });
              setCategoryFilter([]);
              setTypeOfEncroachmentFilter([]);
              setSearchParams({});
            }}
          >
            Clear Filters
          </Button>
        </Box>
      )}

      <Box
        overflowX="auto"
        borderRadius="md"
        boxShadow="md"
        maxHeight="60vh"
        bg={tableBg}
      >
        <Table
          size={'sm'}
          variant="simple"
          minW="1200px"
          sx={{
            'th, td': {
              borderColor: borderColor,
              color: textColor,
            },
          }}
        >
          <Thead
            position="sticky"
            top={0}
            zIndex={1}
            bgGradient={headerGradient}
          >
            <Tr>
              <Th color="white" whiteSpace="nowrap">
                {user?.role === 'tahsildar' && (
                  <Checkbox
                    colorScheme="green"
                    border="black"
                    isChecked={
                      surveyData.length > 0 &&
                      selectedSurveyIds.length === surveyData.length
                    }
                    isIndeterminate={
                      selectedSurveyIds.length > 0 &&
                      selectedSurveyIds.length < surveyData.length
                    }
                    onChange={(e) =>
                      setSelectedSurveyIds(
                        e.target.checked
                          ? surveyData.map((row) => row._id)
                          : [],
                      )
                    }
                  >
                    <Text fontSize="12" fontWeight="bold">
                      All
                    </Text>
                  </Checkbox>
                )}
              </Th>
              <Th color="white" whiteSpace="nowrap">
                <Flex justify="center" align="center" height="100%">
                  Sr. No
                </Flex>
              </Th>
              <Th color="white" display={{ base: 'none', md: 'table-cell' }}>
                Division
              </Th>
              <Th color="white">District</Th>
              <Th color="white" display={{ base: 'none', md: 'table-cell' }}>
                Taluka
              </Th>
              <Th color="white">Village</Th>
              <Th color="white" whiteSpace="nowrap">
                Encroacher Name
              </Th>
              <Th color="white" whiteSpace="nowrap">
                Encroachment Date
              </Th>
              <Th color="white">Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {loading ? (
              [...Array(6)].map((_, i) => (
                <Tr key={`skeleton-row-${i}`}>
                  {Array.from({ length: 10 }).map((_, j) => (
                    <Td key={`skeleton-cell-${j}`}>
                      <Skeleton height="16px" width="100%" />
                    </Td>
                  ))}
                </Tr>
              ))
            ) : error ? (
              <Tr>
                <Td colSpan={10} textAlign="center">
                  <Text color={previousColor}>{error}</Text>
                </Td>
              </Tr>
            ) : surveyData.length === 0 ? (
              <Tr>
                <Td colSpan={10} textAlign="center">
                  No matching records found.
                </Td>
              </Tr>
            ) : (
              surveyData.map((row, index) => {
                const startingSerialNumber = (page - 1) * rowsPerPage + 1;
                const rowBg = index % 2 === 0 ? rowEvenBg : rowOddBg;
                return (
                  <Tr
                    key={row._id}
                    onClick={() => handleViewClick(row)}
                    _hover={{ bg: hoverRowBg, cursor: 'pointer' }}
                    bg={rowBg}
                    fontSize="sm"
                    lineHeight="short"
                  >
                    <Td py={2} px={3} onClick={(e) => e.stopPropagation()}>
                      {user?.role === 'tahsildar' ? (
                        <Flex justify="center" align="center" height="100%">
                          <Checkbox
                            colorScheme="green"
                            border="black"
                            isChecked={selectedSurveyIds.includes(row._id)}
                            onChange={(e) => {
                              e.stopPropagation();
                              const checked = e.target.checked;
                              setSelectedSurveyIds((prev) =>
                                checked
                                  ? [...prev, row._id]
                                  : prev.filter((id) => id !== row._id),
                              );
                            }}
                          />
                        </Flex>
                      ) : null}
                    </Td>
                    <Td py={2} px={3}>
                      <Flex justify="center" align="center" height="100%">
                        {startingSerialNumber + index}
                      </Flex>
                    </Td>
                    <Td
                      py={2}
                      px={3}
                      display={{ base: 'none', md: 'table-cell' }}
                    >
                      {row.division?.name?.toUpperCase() || 'N/A'}
                    </Td>
                    <Td py={2} px={3}>
                      {row.district?.name?.toUpperCase() || 'N/A'}
                    </Td>
                    <Td
                      py={2}
                      px={3}
                      display={{ base: 'none', md: 'table-cell' }}
                    >
                      {row.tahsil?.name?.toUpperCase() || 'N/A'}
                    </Td>
                    <Td py={2} px={3}>
                      {row.village?.name?.toUpperCase() || 'N/A'}
                    </Td>
                    <Td py={2} px={3}>
                      {row.encroacherName?.toUpperCase() || 'N/A'}
                    </Td>
                    <Td py={2} px={3} whiteSpace="nowrap">
                      {moment(row.encroachmentYear).format('DD-MM-YYYY')}{' '}
                    </Td>
                    <Td py={2} px={3}>
                      {row.status?.toUpperCase()}
                    </Td>
                  </Tr>
                );
              })
            )}
          </Tbody>
        </Table>
      </Box>

      {renderPagination()}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent maxW="900px" mx="auto" rounded="lg" shadow="lg">
          <Box
            bg={modalHeaderBg}
            color={modalHeaderColor}
            py={2}
            textAlign="center"
            roundedTop="lg"
          >
            <ModalHeader fontSize="2xl" fontWeight="bold">
              <Icon as={InfoOutlineIcon} mr={2} />
              SURVEY DETAILS
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody>
            {selectedSurvey ? (
              <Box p={4}>
                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color={sectionHeadingColor}
                  >
                    <Icon as={FaLandmark} mr={2} />
                    Basic Land Information
                  </Text>
                  <Box
                    bg={sectionBoxBg}
                    p={4}
                    rounded="md"
                    shadow="md"
                    color={sectionTextColor}
                    borderColor={sectionBorderColor}
                  >
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <Box>
                        <Text fontWeight="bold">Division:</Text>
                        <Text>
                          {capitalizeFirst(
                            selectedSurvey.division?.name || 'N/A',
                          )}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">District:</Text>
                        <Text>
                          {capitalizeFirst(
                            selectedSurvey.district?.name || 'N/A',
                          )}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Taluka:</Text>
                        <Text>
                          {capitalizeFirst(
                            selectedSurvey.tahsil?.name || 'N/A',
                          )}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Village:</Text>
                        <Text>
                          {capitalizeFirst(
                            selectedSurvey.village?.name || 'N/A',
                          )}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Gat No:</Text>
                        <Text>{selectedSurvey.gatNumber || 'N/A'}</Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Total Area:</Text>
                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        (comparisonData.totalAreaInHec !==
                          selectedSurvey.totalAreaInHec ||
                          comparisonData.totalAreaInSqft !==
                            selectedSurvey.totalAreaInSqft ||
                          comparisonData.totalAreaInSqmt !==
                            selectedSurvey.totalAreaInSqmt) ? (
                          <>
                            <Text>
                              {[
                                selectedSurvey.totalAreaInHec &&
                                  `${selectedSurvey.totalAreaInHec} ha`,
                                selectedSurvey.totalAreaInSqft &&
                                  `${selectedSurvey.totalAreaInSqft} sq.ft`,
                                selectedSurvey.totalAreaInSqmt &&
                                  `${selectedSurvey.totalAreaInSqmt} sq.mt`,
                              ]
                                .filter(Boolean)
                                .join(' / ')}
                            </Text>
                            {user?.role === 'tahsildar' &&
                              (comparisonData.totalAreaInHec ||
                                comparisonData.totalAreaInSqft ||
                                comparisonData.totalAreaInSqmt) && (
                                <Text color={previousColor}>
                                  <strong>Previous:</strong>{' '}
                                  {[
                                    comparisonData.totalAreaInHec &&
                                      `${comparisonData.totalAreaInHec} ha`,
                                    comparisonData.totalAreaInSqft &&
                                      `${comparisonData.totalAreaInSqft} sq.ft`,
                                    comparisonData.totalAreaInSqmt &&
                                      `${comparisonData.totalAreaInSqmt} sq.mt`,
                                  ]
                                    .filter(Boolean)
                                    .join(' / ')}
                                </Text>
                              )}
                          </>
                        ) : (
                          <Text>
                            {[
                              selectedSurvey.totalAreaInHec &&
                                `${selectedSurvey.totalAreaInHec} ha`,
                              selectedSurvey.totalAreaInSqft &&
                                `${selectedSurvey.totalAreaInSqft} sq.ft`,
                              selectedSurvey.totalAreaInSqmt &&
                                `${selectedSurvey.totalAreaInSqmt} sq.mt`,
                            ]
                              .filter(Boolean)
                              .join(' / ')}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Encroached Area:</Text>
                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        (comparisonData.encroachedAreaInHec !==
                          selectedSurvey.encroachedAreaInHec ||
                          comparisonData.encroachedAreaInSqft !==
                            selectedSurvey.encroachedAreaInSqft ||
                          comparisonData.encroachedAreaInSqmt !==
                            selectedSurvey.encroachedAreaInSqmt) ? (
                          <>
                            <Text>
                              {[
                                selectedSurvey.encroachedAreaInHec &&
                                  `${selectedSurvey.encroachedAreaInHec} ha`,
                                selectedSurvey.encroachedAreaInSqft &&
                                  `${selectedSurvey.encroachedAreaInSqft} sq.ft`,
                                selectedSurvey.encroachedAreaInSqmt &&
                                  `${selectedSurvey.encroachedAreaInSqmt} sq.mt`,
                              ]
                                .filter(Boolean)
                                .join(' / ')}
                            </Text>
                            {user?.role === 'tahsildar' &&
                              (comparisonData.encroachedAreaInHec ||
                                comparisonData.encroachedAreaInSqft ||
                                comparisonData.encroachedAreaInSqmt) && (
                                <Text color={previousColor}>
                                  <strong>Previous:</strong>{' '}
                                  {[
                                    comparisonData.encroachedAreaInHec &&
                                      `${comparisonData.encroachedAreaInHec} ha`,
                                    comparisonData.encroachedAreaInSqft &&
                                      `${comparisonData.encroachedAreaInSqft} sq.ft`,
                                    comparisonData.encroachedAreaInSqmt &&
                                      `${comparisonData.encroachedAreaInSqmt} sq.mt`,
                                  ]
                                    .filter(Boolean)
                                    .join(' / ')}
                                </Text>
                              )}
                          </>
                        ) : (
                          <Text>
                            {[
                              selectedSurvey.encroachedAreaInHec &&
                                `${selectedSurvey.encroachedAreaInHec} ha`,
                              selectedSurvey.encroachedAreaInSqft &&
                                `${selectedSurvey.encroachedAreaInSqft} sq.ft`,
                              selectedSurvey.encroachedAreaInSqmt &&
                                `${selectedSurvey.encroachedAreaInSqmt} sq.mt`,
                            ]
                              .filter(Boolean)
                              .join(' / ')}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Encroachment Date:</Text>
                        <Text>
                          {selectedSurvey.encroachmentYear
                            ? (() => {
                                const date = new Date(
                                  selectedSurvey.encroachmentYear,
                                );
                                date.setMinutes(date.getMinutes() + 330); // Adjust for IST
                                return `${String(date.getDate()).padStart(
                                  2,
                                  '0',
                                )}-${String(date.getMonth() + 1).padStart(
                                  2,
                                  '0',
                                )}-${date.getFullYear()}`;
                              })()
                            : 'N/A'}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Status:</Text>
                        <Text
                          fontWeight="semibold"
                          color={
                            selectedSurvey.status === 'approved'
                              ? 'green.500'
                              : selectedSurvey.status === 'rejected'
                              ? 'red.500'
                              : selectedSurvey.status === 'pending'
                              ? 'blue.500'
                              : selectedSurvey.status === 'talatiview'
                              ? 'purple.500'
                              : 'gray.500'
                          }
                        >
                          {capitalizeFirst(
                            selectedSurvey.status?.toUpperCase() || 'N/A',
                          )}
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Box>
                </Box>

                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color={headingColor}
                  >
                    <Icon as={FaUserShield} mr={2} />
                    Encroacher Information
                  </Text>
                  <Box bg={sectionBoxBg} p={4} rounded="md" shadow="md">
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <Box>
                        <Text fontWeight="bold">Name:</Text>
                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.encroacherName !==
                          selectedSurvey.encroacherName ? (
                          <>
                            <Text>
                              {' '}
                              {capitalizeFirst(
                                selectedSurvey.encroacherName || 'N/A',
                              )}
                            </Text>
                            {user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(comparisonData.encroacherName)}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.encroacherName || 'N/A',
                            )}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Address:</Text>

                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.encroacherAddress !==
                          selectedSurvey.encroacherAddress ? (
                          <>
                            <Text>
                              {' '}
                              {capitalizeFirst(
                                selectedSurvey.encroacherAddress || 'N/A',
                              )}
                            </Text>
                            {user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(
                                  comparisonData.encroacherAddress,
                                )}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.encroacherAddress || 'N/A',
                            )}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Caste:</Text>

                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.caste !== selectedSurvey.caste ? (
                          <>
                            <Text>
                              {' '}
                              {capitalizeFirst(selectedSurvey.caste || 'N/A')}
                            </Text>
                            {user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(comparisonData.caste)}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(selectedSurvey.caste || 'N/A')}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">BPL Family:</Text>
                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.isBPLFamily !==
                          selectedSurvey.isBPLFamily ? (
                          <>
                            <Text>
                              {selectedSurvey.isBPLFamily ? 'Yes' : 'No'}
                            </Text>
                            {user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {comparisonData.isBPLFamily ? 'Yes' : 'No'}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {comparisonData
                              ? comparisonData.isBPLFamily
                                ? 'Yes'
                                : 'No'
                              : selectedSurvey.isBPLFamily
                              ? 'Yes'
                              : 'No'}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Annual Income:</Text>
                        <Text>
                          {(() => {
                            const cleaned =
                              selectedSurvey.annualIncome?.replace(
                                /[^\d]/g,
                                '',
                              );
                            const num = Number(cleaned);
                            if (isNaN(num)) {
                              return `${
                                selectedSurvey.annualIncome || 'N/A'
                              } (Invalid Format)`;
                            }
                            return `₹${num.toLocaleString('en-IN')} (${
                              num < 250000
                                ? 'Less than 2.5 lakh'
                                : 'Greater than 2.5 lakh'
                            })`;
                          })()}
                        </Text>

                        {/* Show previous value only if status is pending and different */}
                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData.annualIncome !==
                            selectedSurvey.annualIncome &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {(() => {
                                const cleaned =
                                  comparisonData.annualIncome?.replace(
                                    /[^\d]/g,
                                    '',
                                  );
                                const num = Number(cleaned);
                                if (isNaN(num)) {
                                  return `${comparisonData.annualIncome} (Invalid Format)`;
                                }
                                return `₹${num.toLocaleString('en-IN')} (${
                                  num < 250000
                                    ? 'Less than 2.5 lakh'
                                    : 'Greater than 2.5 lakh'
                                })`;
                              })()}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Social Category Details:</Text>

                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.socialCategoryDetails !==
                          selectedSurvey.socialCategoryDetails ? (
                          <>
                            <Text>
                              {capitalizeFirst(
                                selectedSurvey.socialCategoryDetails || 'N/A',
                              )}
                            </Text>
                            {user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(
                                  comparisonData.socialCategoryDetails || 'N/A',
                                )}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.socialCategoryDetails || 'N/A',
                            )}
                          </Text>
                        )}
                      </Box>

                      {selectedSurvey.socialCategory &&
                        Object.entries(selectedSurvey.socialCategory)
                          .filter(([_, value]) => value && value !== '-')
                          .map(([key, value]) => (
                            <Box key={key}>
                              <Text fontWeight="bold">
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}:
                              </Text>
                              <Text>{capitalizeFirst(value || 'N/A')}</Text>
                            </Box>
                          ))}
                    </SimpleGrid>
                  </Box>
                </Box>

                {selectedSurvey.typeOfEncroachment && (
                  <Box mb={6}>
                    <Text
                      fontSize="lg"
                      fontWeight="bold"
                      mb={4}
                      color={sectionTitleColor}
                    >
                      <Icon as={FaTools} mr={2} />
                      Type of Encroachment
                    </Text>
                    <Box bg={sectionBoxBg} p={4} rounded="md" shadow="md">
                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        {Object.entries(selectedSurvey.typeOfEncroachment)
                          .filter(([_, value]) => value && value !== '-')
                          .map(([key, currentValue]) => {
                            const originalValue =
                              comparisonData?.typeOfEncroachment?.[key] || '';
                            const wasPresentBefore =
                              key in (comparisonData?.typeOfEncroachment || {});
                            const isChanged =
                              wasPresentBefore &&
                              originalValue !== currentValue;
                            const isNewlyAdded = !wasPresentBefore;

                            return (
                              <Box key={key}>
                                <Text fontWeight="bold">
                                  {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                  :
                                </Text>

                                {isNewlyAdded ? (
                                  <Text>
                                    {capitalizeFirst(currentValue || 'N/A')}
                                  </Text>
                                ) : isChanged ? (
                                  <>
                                    <Text>
                                      {capitalizeFirst(originalValue || 'N/A')}
                                    </Text>
                                    {user?.role === 'tahsildar' && (
                                      <Text color={previousColor}>
                                        <strong>Previous:</strong>{' '}
                                        {capitalizeFirst(originalValue)}
                                      </Text>
                                    )}
                                  </>
                                ) : (
                                  <Text>
                                    {capitalizeFirst(currentValue || 'N/A')}
                                  </Text>
                                )}
                              </Box>
                            );
                          })}
                      </SimpleGrid>
                    </Box>
                  </Box>
                )}

                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color={sectionTitleColor}
                  >
                    <Icon as={FaMapMarkerAlt} mr={2} />
                    Location & Documents
                  </Text>
                  <Box bg={sectionBoxBg} p={4} rounded="md" shadow="md">
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      {/* Map Location */}
                      {selectedSurvey.imagesLocation?.coordinates?.length ===
                        2 && (
                        <Box>
                          <Text fontWeight="bold">Map Location:</Text>
                          <a
                            href={`https://www.google.com/maps?q=${selectedSurvey.imagesLocation.coordinates[1]},${selectedSurvey.imagesLocation.coordinates[0]}`}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              color: 'green',
                              textDecoration: 'underline',
                            }}
                          >
                            <MdLocationOn style={{ display: 'inline' }} /> View
                            on Map
                          </a>
                        </Box>
                      )}

                      {/* Document Type */}
                      <Box>
                        <Text fontWeight="bold">Document Type:</Text>

                        {comparisonData &&
                        comparisonData.documentType !==
                          selectedSurvey.documentType ? (
                          <>
                            <Text>
                              {capitalizeFirst(
                                selectedSurvey.documentType || 'N/A',
                              )}
                            </Text>

                            {selectedSurvey.status === 'pending' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(comparisonData.documentType)}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.documentType || 'N/A',
                            )}
                          </Text>
                        )}
                      </Box>

                      {/* Document Proof of Encroachment */}
                      {hasValue(selectedSurvey.documentPhoto) && (
                        <Box>
                          <Text fontWeight="bold">
                            Document Proof of Encroachment:
                          </Text>
                          <a
                            href={
                              selectedSurvey.documentPhoto.startsWith('http')
                                ? selectedSurvey.documentPhoto
                                : `${baseUrl}/${selectedSurvey.documentPhoto}`
                            }
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              color: 'blue',
                              textDecoration: 'underline',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '5px',
                            }}
                          >
                            <MdImage /> View Document Photo
                          </a>
                        </Box>
                      )}

                      {/* Proof of BPL Family */}
                      {hasValue(selectedSurvey.uploadProof) && (
                        <Box>
                          <Text fontWeight="bold">Proof of BPL Family:</Text>
                          <a
                            href={
                              selectedSurvey.uploadProof.startsWith('http')
                                ? selectedSurvey.uploadProof
                                : `${baseUrl}/${selectedSurvey.uploadProof}`
                            }
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              color: 'blue',
                              textDecoration: 'underline',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '5px',
                            }}
                          >
                            <MdImage /> View Upload Proof
                          </a>
                        </Box>
                      )}

                      {selectedSurvey.imagesArray?.length > 0 && (
                        <Box>
                          <Text fontWeight="bold">
                            Photographic Proof of Encroachment:
                          </Text>
                          {selectedSurvey.imagesArray.map((photoUrl, index) => (
                            <Box key={index} mb={2}>
                              <a
                                href={
                                  photoUrl?.startsWith('http')
                                    ? photoUrl
                                    : `${baseUrl}/${photoUrl}`
                                }
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: 'blue',
                                  textDecoration: 'underline',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '5px',
                                }}
                              >
                                <MdImage /> View Image {index + 1}
                              </a>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </SimpleGrid>
                  </Box>
                </Box>

                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color={sectionRedTitleColor}
                  >
                    <Icon as={MdInfo} mr={2} />
                    Additional Information
                  </Text>
                  <Box bg={sectionBoxBg} p={4} rounded="md" shadow="md">
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      {selectedSurvey.otherEncroachmentDetails && (
                        <Box>
                          <Text fontWeight="bold">
                            Other Encroachment Details:
                          </Text>

                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.otherEncroachmentDetails,
                            )}
                          </Text>

                          {selectedSurvey.status === 'pending' &&
                            comparisonData &&
                            comparisonData.otherEncroachmentDetails !==
                              selectedSurvey.otherEncroachmentDetails &&
                            user?.role === 'tahsildar' && (
                              <Text color={previousColor}>
                                <strong>Previous:</strong>{' '}
                                {capitalizeFirst(
                                  comparisonData?.otherEncroachmentDetails,
                                )}
                              </Text>
                            )}
                        </Box>
                      )}
                      <Box>
                        <Text fontWeight="bold">Number of Family Members:</Text>

                        <Text>
                          {capitalizeFirst(selectedSurvey?.noOfFamilyMembers)}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData?.noOfFamilyMembers !==
                            selectedSurvey?.noOfFamilyMembers &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {capitalizeFirst(
                                comparisonData?.noOfFamilyMembers,
                              )}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Dependent Members:</Text>

                        <Text>
                          {capitalizeFirst(selectedSurvey?.dependentMembers)}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData?.dependentMembers !==
                            selectedSurvey?.dependentMembers &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {capitalizeFirst(
                                comparisonData?.dependentMembers,
                              )}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">
                          Government Scheme Support:
                        </Text>

                        <Text>
                          {capitalizeFirst(
                            selectedSurvey.isGovSchemeSupport
                              ? selectedSurvey.isGovSchemeSupport
                              : '',
                          )}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData.isGovSchemeSupport !==
                            selectedSurvey.isGovSchemeSupport &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {capitalizeFirst(
                                comparisonData?.isGovSchemeSupport
                                  ? comparisonData?.isGovSchemeSupport
                                  : '',
                              )}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Government Scheme Name:</Text>
                        <Text>
                          {capitalizeFirst(selectedSurvey.govSchemeName)}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData.govSchemeName !==
                            selectedSurvey.govSchemeName &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {capitalizeFirst(comparisonData?.govSchemeName)}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Case Filed:</Text>
                        <Text>
                          {capitalizeFirst(selectedSurvey?.caseFiled)}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData.caseFiled !==
                            selectedSurvey.caseFiled &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous: </strong>
                              {capitalizeFirst(comparisonData?.caseFiled)}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Court Case Details:</Text>
                        <Text>
                          {capitalizeFirst(selectedSurvey.courtCaseDetails)}
                        </Text>

                        {selectedSurvey.status === 'pending' &&
                          comparisonData &&
                          comparisonData.courtCaseDetails !==
                            selectedSurvey.courtCaseDetails &&
                          user?.role === 'tahsildar' && (
                            <Text color={previousColor}>
                              <strong>Previous: </strong>
                              {capitalizeFirst(comparisonData.courtCaseDetails)}
                            </Text>
                          )}
                      </Box>

                      <Box>
                        <Text fontWeight="bold">Talati Remark:</Text>

                        {selectedSurvey.status === 'pending' &&
                        comparisonData &&
                        comparisonData.talatiRemark !==
                          selectedSurvey.socialCategoryDetails ? (
                          <>
                            <Text color={previousColor}>
                              <strong>Previous:</strong>{' '}
                              {capitalizeFirst(comparisonData.talatiRemark)}
                            </Text>
                          </>
                        ) : (
                          <Text>
                            {capitalizeFirst(
                              selectedSurvey.talatiRemark || 'N/A',
                            )}
                          </Text>
                        )}
                      </Box>

                      <Box>
                        {/* Remark & Rejection Comment */}
                        {selectedSurvey.status === 'rejected' &&
                          selectedSurvey.remark && (
                            <Box>
                              <Text fontWeight="bold">Remark:</Text>
                              <Text>
                                {capitalizeFirst(selectedSurvey.remark)}
                              </Text>
                            </Box>
                          )}

                        {selectedSurvey.status === 'rejected' &&
                          selectedSurvey.rejectionComment && (
                            <Box>
                              <Text fontWeight="bold">Rejection Comment:</Text>
                              <Text>
                                {capitalizeFirst(
                                  selectedSurvey.rejectionComment,
                                )}
                              </Text>
                            </Box>
                          )}
                      </Box>
                    </SimpleGrid>
                  </Box>
                </Box>

                {selectedSurvey.encroacherSignature && (
                  <Box mb={6}>
                    <Box bg={boxBg} p={4} rounded="md" shadow="md">
                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <Image
                            src={
                              selectedSurvey.encroacherSignature.startsWith(
                                'http',
                              )
                                ? selectedSurvey.encroacherSignature
                                : `${baseUrl}/${selectedSurvey.encroacherSignature}`
                            }
                            alt="Encroacher's Signature"
                            maxH="80px"
                            mt={2}
                            border="1px solid #ccc"
                            borderRadius="md"
                          />
                          <Box
                            as="hr"
                            borderColor={hrColor}
                            maxW={'210px'}
                            mt={2}
                          />
                          <Box display="flex" paddingLeft={'10%'}>
                            <Text color={textColor} fontSize="14px">
                              Signature of Encroacher
                            </Text>
                          </Box>
                        </Box>
                      </SimpleGrid>
                    </Box>
                  </Box>
                )}

                {user?.role === 'tahsildar' &&
                  selectedSurvey.status === 'pending' && (
                    <Box mt={6} bg={boxBg} p={4} rounded="md" shadow="md">
                      <Text fontWeight="semibold" mb={2} color={textColor}>
                        Remark (optional for approval, required for rejection)
                      </Text>
                      <Textarea
                        placeholder="Enter remark here..."
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        mb={4}
                        color={textColor}
                        _placeholder={{ color: placeholderColor }}
                      />
                      <Stack direction="row" spacing={4} justify="flex-end">
                        <Button
                          colorScheme="green"
                          onClick={approveSurvey}
                          isLoading={isApproving}
                          loadingText="Approving"
                        >
                          Approve
                        </Button>

                        <Button
                          colorScheme="red"
                          onClick={rejectSurvey}
                          isLoading={isRejecting}
                          loadingText="Rejecting"
                        >
                          Reject
                        </Button>
                      </Stack>
                    </Box>
                  )}
              </Box>
            ) : (
              <Text>No details available.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
